export default __webpack_public_path__ + "static/media/KOD0053-min.f7ccfe85.webp";